const state = () => ({
  data: null,
  isError: false,
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  async setLoading({ commit }, loading) {
    commit('SET_LOADING', loading)
  },
}

// mutations
const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
